import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import authService from "../services/auth";

function PrivateRoute({ children, requireAnalista = false }) {
  const [user, setUser] = useState(authService.getCurrentUser());
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const isAnalistaRoute = location.pathname === "/dashboard-analista";

  useEffect(() => {
    const updateUserProfile = async () => {
      try {
        if (user) {
          if (isAnalistaRoute || requireAnalista) {
            const updatedUser = await authService.atualizarPerfil();
            if (updatedUser) {
              setUser(updatedUser);
            }
          }
        }
      } catch (error) {
        console.error("Erro ao atualizar perfil do usuário:", error);
      } finally {
        setLoading(false);
      }
    };

    updateUserProfile();
  }, [user, isAnalistaRoute, requireAnalista]);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="80vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if ((isAnalistaRoute || requireAnalista) && !user.data.isAnalista) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="80vh"
      >
        <Typography variant="h5" gutterBottom>
          Acesso restrito
        </Typography>
        <Typography variant="body1" gutterBottom>
          Esta área é restrita a analistas. Você não tem permissões de analista
          para acessar esta página.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => (window.location.href = "/dashboard")}
          sx={{ mt: 2 }}
        >
          Voltar para o Dashboard
        </Button>
      </Box>
    );
  }

  return children;
}

export default PrivateRoute;
